module.exports = __webpack_public_path__ + "../static/img/base_huawei.be8a60c1.png";